import { getGenericSpacing } from '../../../design-tokens/style-mixins';
/**
 * Panel Helpers
 */
export const getGenericPanelPadding = getGenericSpacing('padding');
export const getGenericPanelMargin = getGenericSpacing('margin');
